/** QuickTicketing — Formulaire « Signaler un problème ».
 *
 * Pré-remplissage par l'adresse, pour un lien « Signaler un problème » posé dans une
 * autre app de la suite : #/nouveau?app=plan&url=<page où l'on était>&version=0.4.0
 */
import React, { useState } from 'react';
import { api } from '../api/client.js';
import { useAttachments, AttachmentPicker } from './Attachments.jsx';
import { payload } from '../attachments.js';

export default function NewTicket({ meta, params, navigate }) {
  const known = meta.apps.some((a) => a.id === params.get('app'));
  const [form, setForm] = useState({
    app: known ? params.get('app') : '',
    type: 'bug',
    severity: 'genant',
    title: '',
    description: '',
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const att = useAttachments();
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target ? e.target.value : e }));
  const context = { url: params.get('url') || document.referrer || '', version: params.get('version') || '', userAgent: navigator.userAgent };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.app) return setError('Choisissez l\'application concernée.');
    setBusy(true);
    setError(null);
    try {
      const t = await api('/tickets', { method: 'POST', body: { ...form, context, attachments: payload(att.files) } });
      navigate(`/t/${t.id}`);
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <form className="page narrow card form" onSubmit={submit} onPaste={att.onPaste}>
      <h2>Signaler un problème</h2>
      <p className="muted">Décrivez ce qui s'est passé : un administrateur le qualifie, puis il est analysé et corrigé. Vous suivez l'avancement ici et confirmez la résolution.</p>

      <label>Application concernée
        <select value={form.app} onChange={set('app')} required>
          <option value="">— choisir —</option>
          {meta.apps.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      </label>

      <div className="row wrap gap-l">
        <div>
          <div className="lbl">Nature</div>
          <div className="seg">
            {meta.types.map((t) => <button type="button" key={t.id} className={form.type === t.id ? 'active' : ''} onClick={() => set('type')(t.id)}>{t.label}</button>)}
          </div>
        </div>
        <div>
          <div className="lbl">Gravité</div>
          <div className="seg">
            {meta.severities.map((s) => <button type="button" key={s.id} title={s.hint} className={form.severity === s.id ? 'active' : ''} onClick={() => set('severity')(s.id)}>{s.label}</button>)}
          </div>
        </div>
      </div>

      <label>Titre
        <input value={form.title} onChange={set('title')} maxLength={160} placeholder="ex. L'export PDF reste bloqué à 0 %" required />
      </label>

      <label>Description
        <textarea
          rows={9}
          value={form.description}
          onChange={set('description')}
          placeholder={'Ce que vous faisiez, ce qui s\'est passé, ce que vous attendiez.\nÉtapes pour reproduire si possible.'}
          required
        />
      </label>

      <AttachmentPicker att={att} />
      {context.url && <div className="muted">Page d'origine : <code>{context.url}</code></div>}

      {error && <div className="error-line">{error}</div>}
      <div className="row">
        <span className="grow" />
        <button type="button" onClick={() => navigate('/')}>Annuler</button>
        <button type="submit" className="primary" disabled={busy}>{busy ? <span className="spinner" /> : 'Envoyer le ticket'}</button>
      </div>
    </form>
  );
}
